import React from 'react';
import PropTypes from 'prop-types';
import { Bolt } from '@mui/icons-material';
import { Link } from 'react-router-dom';

const ScreenStatePanel = ({ title, body, ctaLabel, ctaPath }) => {
  return (
    <div className="flex min-h-[220px] items-center justify-center">
      <div className="w-full max-w-2xl rounded-2xl border border-slate-200 bg-slate-50 p-6 text-center shadow-sm dark:border-slate-700 dark:bg-slate-900/60">
        <div className="mx-auto flex h-12 w-12 items-center justify-center rounded-2xl bg-blue-100 text-blue-700 dark:bg-blue-900/40 dark:text-blue-200">
          <Bolt className="h-5 w-5" />
        </div>
        <h3 className="mt-4 text-lg font-bold text-slate-900 dark:text-slate-100">
          {title}
        </h3>
        <p className="mt-3 text-sm leading-relaxed text-slate-600 dark:text-slate-300">
          {body}
        </p>
        {ctaLabel && ctaPath ? (
          <p className="mt-4 text-sm">
            <Link
              to={ctaPath}
              className="font-semibold text-blue-600 underline hover:text-blue-700 dark:text-blue-300 dark:hover:text-blue-200"
            >
              {ctaLabel}
            </Link>
          </p>
        ) : null}
      </div>
    </div>
  );
};

ScreenStatePanel.propTypes = {
  title: PropTypes.string.isRequired,
  body: PropTypes.string.isRequired,
  ctaLabel: PropTypes.string,
  ctaPath: PropTypes.string
};

export default ScreenStatePanel;
